<template>
  <b-modal ref="modal" title="Edit Report Tag" no-close-on-backdrop @close="onCancel">
    <b-form @submit.prevent="submit">
      <validation-summary :errors="errors"></validation-summary>
      <v-form-group :validator="$v.selectedTag" label="Tag">
        <v-select v-model="selectedTag"
                  :options="tags"
                  placeholder="Tag"
                  :clearable="false" />
      </v-form-group>
    </b-form>
    <div slot="modal-footer">
      <b-btn @click="onCancel" variant="outline-secondary">Cancel</b-btn>
      <b-btn :loading="loading" variant="success" @click="submit">Update</b-btn>
    </div>
  </b-modal>
</template>

<script>
  import { required } from "vuelidate/lib/validators";

  import modalFormMixin from 'mixins/modal-form-mixin';

  import { mapActions, mapState } from 'vuex';

  import reportService from "services/report-service";

  export default {
    mixins: [modalFormMixin],

    props: {
      clientId: {
        type: Number
      }
    },

    validations: {
      selectedTag: { required }
    },

    data() {
      return {
        selectedTag: null,
        form: {
          reportId: null,
          tagId: null
        }
      }
    },

    computed: {
      ...mapState('tag', ['tags'])
    },

    methods: {
      ...mapActions('tag', ['getTagSelectList']),

      async beforeShow(reportId) {
        await this.getTagSelectList(this.clientId);

        this.form = await reportService.getReportTagForm(reportId);
        this.selectedTag = this.tags.find(t => parseInt(t.value) === this.form.tagId);
      },

      async onSubmit() {
        this.form.tagId = this.selectedTag.value;

        await reportService.updateReportTag(this.form);
      },

      onCancel() {
        this.cancel();

        this.$emit('cancel');
      }
    }
  }
</script>